import { Grid, Typography, Button } from '@material-ui/core';
import { mdiChatOutline } from '@mdi/js';
import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '@mdi/react';
import classes from "./style.module.scss"
import ProfileCard from '../../components/Cards/profileCard';
import usersRepository from 'client-sdk/src/Repository/users-repository';
import handleError from '../../utils/handleError';


const Profile: FunctionComponent<any> = (props: any) => {
    const [user, setUser] = useState(null)
    const userId = localStorage.getItem("userId");
    useEffect(() => {
        getUserWithId(userId)
    }, [])

    const getUserWithId = async (id: string) => {
        try {
            const response = await usersRepository.getProfile({})
            setUser(response.data)
        } catch (error) {
            handleError(error)
        }
    }

    return (
        <>
            <Grid
                className={classes.topBox}
                container
                direction="row"
                justify="space-between"
                alignItems="center"
            >
                <div className={classes.headerBox}>
                    <Typography variant="h6" component="h2">
                        حساب کاربری
                    </Typography>
                </div>
            </Grid>
            <div className={classes.container}>
                <ProfileCard data={user} />
            </div>
        </>
    )
}

export default Profile;